/* eslint-disable @next/next/no-img-element */

import React from 'react';

import styles from './styles.module.scss'
import TextAccordion from '../TextAccordion';

interface ImageSectionProps {
  image: string;
  name: string;
  position: string;
  mainText: string;
  secondaryText: string | JSX.Element;
}

export default function BioSection({ image, name, position, mainText, secondaryText } : ImageSectionProps)  {
  return (
    <div className={styles.bioSection}>
      <div className={styles.card}>
        <div className={styles.imageHolder}>
          <img className={styles.image} src={image} alt={name} />
        </div>
        
        <div className={styles.nameHolder}>
          <h1 className={styles.name}>{ name }</h1>
          <p className={styles.position}>{ position }</p>
        </div>
      </div>

      <div className={styles.textHolder}>
        <p className={`${styles.textSectionHeader} perfect-subtext`}>{ mainText }</p>
        
        <TextAccordion 
          header='BIO'
          text={secondaryText}
          className={styles.bioAccordion}
        />
      </div>
    </div>
  )
};
